var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1696 23.9232L24.2336 15.8592M16.1696 15.8592L24.2336 23.9232M4.07361 15.0528C5.35683 15.0528 6.5875 15.5625 7.49487 16.4699C8.40225 17.3773 8.91201 18.6079 8.91201 19.8912C8.91201 21.1744 8.40225 22.4051 7.49487 23.3124C6.5875 24.2198 5.35683 24.7296 4.07361 24.7296V27.9552C4.07361 28.8106 4.41345 29.6311 5.01836 30.236C5.62328 30.8409 6.44373 31.1808 7.29921 31.1808H33.104C33.9595 31.1808 34.7799 30.8409 35.3849 30.236C35.9898 29.6311 36.3296 28.8106 36.3296 27.9552V24.7296C35.0464 24.7296 33.8157 24.2198 32.9083 23.3124C32.001 22.4051 31.4912 21.1744 31.4912 19.8912C31.4912 18.6079 32.001 17.3773 32.9083 16.4699C33.8157 15.5625 35.0464 15.0528 36.3296 15.0528V11.8272C36.3296 10.9717 35.9898 10.1512 35.3849 9.54632C34.7799 8.9414 33.9595 8.60156 33.104 8.60156H7.29921C6.44373 8.60156 5.62328 8.9414 5.01836 9.54632C4.41345 10.1512 4.07361 10.9717 4.07361 11.8272V15.0528Z",
    stroke: "white",
    strokeWidth: 1.6128,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketX);
export default __webpack_public_path__ + "static/media/ticket-x.77424c9e9bd02c4d267ff170c75c4552.svg";
export { ForwardRef as ReactComponent };